import da from './da/translation.json';
import de from './de/translation.json';
import en from './en/translation.json';
import es from './es/translation.json';
import fi from './fi/translation.json';
import fr from './fr/translation.json';
import is from './is/translation.json';
import it from './it/translation.json';
import nl from './nl/translation.json';
import no from './no/translation.json';
import pt from './pt/translation.json';
import sl from './sl/translation.json';
import sv from './sv/translation.json';

export const translations = {
  da: {
    translation: da,
  },
  de: {
    translation: de,
  },
  en: {
    translation: en,
  },
  fi: {
    translation: fi,
  },
  is: {
    translation: is,
  },
  sv: {
    translation: sv,
  },
  no: {
    translation: no,
  },
  fr: {
    translation: fr,
  },
  nl: {
    translation: nl,
  },
  pt: {
    translation: pt,
  },
  es: {
    translation: es,
  },
  it: {
    translation: it,
  },
  sl: {
    translation: sl,
  },
} as const;

export default translations;

type ValidPaths<T> = keyof T extends never
  ? never
  : {
      [K in keyof T]: T[K] extends never
        ? never
        : T[K] extends Record<string | number | symbol, unknown>
        ? K extends string
          ? `${K}.${ValidPaths<T[K]>}` | K
          : never
        : K;
    }[keyof T] &
      string;

export type TranslationKey = ValidPaths<typeof translations.en.translation>;

